import React from 'react';
import { Container, Button } from 'react-bootstrap';

export default function StepFinalRechazado({ reset }) {
  return (
    <Container className="form-container text-center">

      <h2 className="form-title">Gracias por tu interés en terminar el liceo.</h2>
      <p>Actualmente las becas que ofrece la Fundación 3F están destinadas exclusivamente a estudiantes que deban como máximo 5 materias para finalizar el bachillerato.</p>
      <p>Te sugerimos explorar la opción de cursar en la modalidad "Libre Asistido" en un liceo de tu preferencia. En el siguiente link encontrarás la lista de liceos que la ofrecen.</p>

      {/* Botón que actúa como enlace */}
      <Button
        as="a"
        href="https://www.dges.edu.uy/sites/default/files/2024-12/Liceos%20con%20Plan%201994%20%E2%80%93%20actualizado%202025_0.pdf"
        target="_blank"
        rel="noopener noreferrer"
        variant="primary"
        className="mt-2 me-2"
      >
        Ver PDF
      </Button>

      {/* Botón para reiniciar */}
      <Button
        variant="primary"
        onClick={reset}
        className="mt-2 me-2"
      >
        Reiniciar formulario
      </Button>
    </Container>
  );
}
